import { ENV } from "../utils";
import { apiFetch } from "./httpClient";

export class Notification {
  async getNotifications() {
    return apiFetch(ENV.API_ROUTES.NOTIFICATION, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  }

  async getNotificationsPaginated(page = 1, limit = 10, filters = {}) {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    if (filters.type) {
      queryParams.append("type", filters.type);
    }
    if (filters.viewed !== undefined && filters.viewed !== "") {
      queryParams.append("viewed", filters.viewed.toString());
    }
    if (filters.search) {
      queryParams.append("search", filters.search);
    }

    return apiFetch(
      `${ENV.API_ROUTES.NOTIFICATION}/paginated?${queryParams.toString()}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
  }

  async broadcastNotification(data) {
    return apiFetch(`${ENV.API_ROUTES.NOTIFICATION}/broadcast`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      expectedStatus: 201,
    });
  }

  async updateNotification(idPost, data) {
    return apiFetch(`${ENV.API_ROUTES.NOTIFICATION}/${idPost}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  }

  async readAllNotifications(receiverId) {
    return apiFetch(`${ENV.API_ROUTES.NOTIFICATION}/readAll`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ receiverId }),
    });
  }

  async deleteNotification(idPost) {
    return apiFetch(`${ENV.API_ROUTES.NOTIFICATION}/${idPost}`, {
      method: "DELETE",
    });
  }
}
